


//메인카테고리의 메뉴가 선택됐을시 효과처리
function onSelectMainCategory(handle){

  var pc_nav = $(".site-nav");
  if(pc_nav.is(":visible")){
    pc_nav.find("a[handle='" + handle +"']").addClass('cl_selected');
  }
  else{
    var mobile_nav_item = $(".cl_mobile_nav  .cl_item[handle='" + handle +"']");
    if(mobile_nav_item.length > 0){
      mobile_nav_item.addClass('cl_selected');
      var item_wrap = mobile_nav_item.closest("a");
      $(".cl_mobile_nav").scrollLeft(item_wrap.scrollLeft() + item_wrap.position().left - ($(window).width()/2) + (item_wrap.width()/2) );

    }
  }

}